import { z } from "zod";

export default {
  params: z.object({
    supervisorOrgId: z.string(),
    userId: z.string(),
  }),
  response: z.void(),
};
